export const DataFields = (t) => {
    return [
      {
        name: "",
        fields: [
          {
            id: "name",
            name: t('builder_categories_form_name'),
            type: "text",
            required: true,
            defaultValue: "",
            size: "small"
          },
          {
            id: "showName",
            name: t('builder_categories_form_show_name'),
            type: "switch",
            required: true,
            defaultValue: false,
            size: "small"
          },
          {
            id: "description",
            name: t('builder_categories_form_description'),
            type: "text",
            required: true,
            defaultValue: "",
            size: "small"
          },
          {
            id: "footer",
            name: t('builder_categories_form_footer'),
            type: "text",
            required: false,
            defaultValue: "",
            size: "small"
          },
          {
            id: "image",
            name: t('builder_categories_form_image'),
            type: "image",
            required: false,
            isImage: true,
            defaultValue: "",
            size: "small"
          },
          {
            id: "imageActive",
            name: t('builder_categories_form_image_active'),
            type: "image",
            required: false,
            isImage: true,
            defaultValue: "",
            size: "small"
          },
          {
            id: "showImage",
            name: t('builder_categories_form_show_image'),
            type: "switch",
            required: true,
            defaultValue: false,
            size: "small"
          },
          {
            id: "headerImage",
            name: t('builder_categories_form_header_image'),
            type: "image",
            required: false,
            isImage: true,
            defaultValue: "",
            size: "small"
          },
          {
            id: "showHeaderImage",
            name: t('builder_categories_form_show_header_image'),
            type: "switch",
            required: true,
            defaultValue: false,
            size: "small"
          },
          {
            id: "active",
            name: t('builder_categories_form_active'),
            type: "switch",
            required: true,
            defaultValue: false,
            size: "small"
          },
        ]
      }
    ]
  }